module.exports = __webpack_public_path__ + "img/bilge.993294b0.svg";